import { createSelector } from 'reselect';

import { createSelectorFactory } from 'wanderu-ducks-utils';

import SLICE_NAMESPACE from '../../../types';
import { serializeFilterParams } from '../../../utils';
import {
    selectReduxSearchParams,
} from '../../search/selectors';
import {
    minimizeFilterSet,
    writeFilterQueryParams,
} from '../filterUtils';
import { INITIAL_SUBSTATE } from '../reducer';
import NAMESPACE from '../types';

function _selectData(state) {
    return state[SLICE_NAMESPACE][NAMESPACE];
}

function selectRawFilterData(state, filterId) {
    return _selectData(state)[filterId] || INITIAL_SUBSTATE;
}

function selectFilterId(state, searchParams) {
    searchParams = searchParams || selectReduxSearchParams(state);
    return serializeFilterParams(searchParams);
}

function selectFilterData(state, searchParams) {
    const filterId = selectFilterId(state, searchParams);
    return selectRawFilterData(state, filterId);
}

function _selectFilterQueryParamsFactory(filterId, direction) {
    return createSelector(
        (state) => selectRawFilterData(state, filterId),
        (rawFilterData) => {
            const minimunFilterSet = minimizeFilterSet(rawFilterData);
            return writeFilterQueryParams(minimunFilterSet, direction);
        },
    );
}
const selectFilterQueryParams = createSelectorFactory(_selectFilterQueryParamsFactory, 2);

export {
    selectFilterData,
    selectFilterId,
    selectFilterQueryParams,
    selectRawFilterData,
};
